import React from "react";
import "./AboutPage.css";
import promiseImg from "../components/Assets/Promise2.jpg";

const WHY_CHOOSE = [
  "Unique and exclusive designs",
  "High-quality materials and craftsmanship",
  "Personalized customer service",
  "Customized jewelry making options",
  "Fast and secure shipping",
  "Above all, customer satisfaction",
];

const AboutPage = () => (
  <div className="about-page">
    <div className="about-body">
      {/* Brand Intro */}
      <section className="about-intro">
        <div className="about-intro-shell">
          <div className="about-intro-card">
            <h2 className="about-section-title center about-brand-name">PANCHALI JEWELS</h2>
            <div className="about-intro-line" />
            <p className="about-intro-text">
              Welcome to <span className="brand-name-gold about-brand-name-inline">Panchali  Jewels</span>, where sparkle meets sophistication.
              We&apos;re passionate about curating exquisite jewelry pieces that tell a story.
              From timeless classics to modern masterpieces, our collection is designed to adorn
              your unique style. With a focus on quality, craftsmanship, and attention to detail,
              we aim to deliver more than just jewelry &ndash; we offer a symbol of love, elegance, and
              self-expression. Explore our collection and discover the perfect piece to shine your light.
            </p>
            <div className="about-intro-line" />
          </div>
        </div>
      </section>

      {/* Customized Jewelry Making */}
      <section className="about-card-section about-card-section--custom-jewelry">
        <div className="about-card">
          <span className="about-card-icon">✨</span>
          <div>
            <h2 className="about-section-title left">Customized Jewelry Making</h2>
            <p>
              At <span className="brand-name-gold about-brand-name-spaced">Panchali Jewels</span>, we understand that every individual
              is unique, and so should their jewelry. That's why we offer customized jewelry making
              services, where our skilled artisans work closely with you to bring your vision to life.
            </p>
            <p>
              From designing a bespoke piece to recreating a family heirloom, our custom jewelry
              services allow you to tell your story through a personalized piece of jewelry.
            </p>
          </div>
        </div>
      </section>

      {/* Our Promise */}
      <section className="about-promise">
        <div className="about-promise-text">
          <h2 className="about-section-title left">Our Promise</h2>
          <p>
            We promise to deliver exceptional quality, attention to details, and a seamless
            customer experience.
          </p>
          <p>
            Our team of expert craftsmen and designers are dedicated to creating Jewelry that not
            only sparkles but also stands the trend, taste and test of time.
          </p>
        </div>
        <div className="about-promise-deco">
          <img src={promiseImg} alt="Our Promise" className="about-promise-diamond-img" />
        </div>
      </section>

      {/* Our Values */}
      <section className="about-card-section">
        <div className="about-card">
          <span className="about-card-icon">💎</span>
          <div>
            <h2 className="about-section-title left">Our Values</h2>
            <p>
              At <span className="brand-name-gold">Panchali Jewels</span>, we value creativity, innovation, and
              customer satisfaction.
            </p>
            <p>
              We're committed to sustainability, responsible sourcing, and eco-friendly practices
              in our jewelry making process.
            </p>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="about-why-section">
        <h2 className="about-section-title center">Why Choose Us</h2>
        <div className="about-why-grid">
          {WHY_CHOOSE.map((item, i) => (
            <div key={i} className="about-why-card">
              <span className="about-why-icon">✦</span>
              <span>{item}</span>
            </div>
          ))}
        </div>
      </section>
    </div>
  </div>
);

export default AboutPage;
